import { render, staticRenderFns } from "./edit_internal.vue?vue&type=template&id=6e7873ae&scoped=true&"
import script from "./edit_internal.vue?vue&type=script&lang=js&"
export * from "./edit_internal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7873ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7873ae')) {
      api.createRecord('6e7873ae', component.options)
    } else {
      api.reload('6e7873ae', component.options)
    }
    module.hot.accept("./edit_internal.vue?vue&type=template&id=6e7873ae&scoped=true&", function () {
      api.rerender('6e7873ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/internal_docs/edit/edit_internal.vue"
export default component.exports